// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7db44d5","455":"3701b5c8"}[chunkId] + ".chunk.js";
};